import z from 'zod';

import { sessionPermissionsUpdatedNotificationSchema } from '@nesso/identity-contracts/session.notifications';
import {
    MAX_INPUT_FIELD_LENGTH as MAX_INPUT_LENGTH,
    practiceMemberAddLicense,
    practiceMemberUpdate,
    practiceMemberUpdateLicense,
    practiceMemberUpdateWelcomeGuide,
    preferredNameSchema as remotePreferredNameSchema,
    titleSchema as remoteTitleSchema,
} from '@nesso/practice-contracts/practice-member.commands';
import {
    getPracticeMemberById,
    getPracticeMemberInsights,
    getPracticeMemberLicenses,
    getPracticeMemberPreferences,
} from '@nesso/practice-contracts/practice-member.queries';
import {
    identifierSchema as remoteIdentifierSchema,
    noteFormatSchema as remoteNoteFormatSchema,
    noteLengthSchema as remoteNoteLengthSchema,
    treatmentApproachesSchema as remoteTreatmentApproachesSchema,
} from '@nesso/practice-contracts/practice-member-settings.models';

export {
    ehrPlatformsInputSchema,
    MAX_EHR_NAME_LENGTH,
    MAX_WHY_LENGTH,
    whyInputSchema,
} from '@nesso/practice-contracts/practice-member.commands';
export { welcomeGuideTasksSchema } from '@nesso/practice-contracts/practice-member.models';

export { sessionPermissionsUpdatedNotificationSchema };
export const getPracticeMemberInsightsOutputSchema = getPracticeMemberInsights.output;
export const getPracticeMemberPreferencesOutputSchema = getPracticeMemberPreferences.output;

export const practiceMemberUpdateWelcomeGuideInputSchema =
    practiceMemberUpdateWelcomeGuide.input.omit({ practiceMemberId: true });

export { onboardingStepsSchema } from '@nesso/practice-contracts/practice-member.models';
export const getPracticeMemberByIdResponseSchema = getPracticeMemberById.output;

export const updatePracticeMemberSchema = practiceMemberUpdate.input.omit({
    practiceMemberId: true,
});

export const MAX_INPUT_FIELD_LENGTH = MAX_INPUT_LENGTH;

export const nameTitleStepSchema = z.object({
    preferredFirstName: remotePreferredNameSchema,
    title: remoteTitleSchema,
});

export const noteFormatStepSchema = z.object({
    noteFormat: remoteNoteFormatSchema,
});

export const noteLengthStepSchema = z.object({
    noteLength: remoteNoteLengthSchema,
});

export const identifierStepSchema = z.object({
    identifier: remoteIdentifierSchema,
});

export const treatmentApproachesStepSchema = z.object({
    treatmentApproaches: remoteTreatmentApproachesSchema,
});

export { npiSchema } from '@nesso/practice-contracts/practice-member.commands';
export { ehrPlatformsSchema } from '@nesso/practice-contracts/practice-member.models';
export {
    identifierSchema,
    noteFormatSchema,
    noteLengthSchema,
    treatmentApproachesSchema,
} from '@nesso/practice-contracts/practice-member-settings.models';

export const getPracticeMemberLicensesOutputSchema = getPracticeMemberLicenses.output;

export const addLicenseSchema = practiceMemberAddLicense.input.omit({ practiceMemberId: true });

// `licenseId` travels as a path param (`PATCH /licenses/{id}`), not a body field — see
// practice-member.api's updateLicense. All four descriptive fields are still required: this is a
// full replacement, matching the command's own contract.
export const updateLicenseSchema = practiceMemberUpdateLicense.input.omit({
    practiceMemberId: true,
    licenseId: true,
});
